import { render, staticRenderFns } from "./layoutNav.vue?vue&type=template&id=1b84c624&scoped=true"
import script from "./layoutNav.vue?vue&type=script&lang=js"
export * from "./layoutNav.vue?vue&type=script&lang=js"
import style0 from "./layoutNav.vue?vue&type=style&index=0&id=1b84c624&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@2.1.1_webpack@4.47.0__lodash@4.18.1_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b84c624",
  null
  
)

export default component.exports